import { render, staticRenderFns } from "./Allegati.vue?vue&type=template&id=6e3cfbec&scoped=true&"
import script from "./Allegati.vue?vue&type=script&lang=js&"
export * from "./Allegati.vue?vue&type=script&lang=js&"
import style0 from "./Allegati.vue?vue&type=style&index=0&id=6e3cfbec&prod&scoped=true&lang=css&"
import style1 from "./Allegati.vue?vue&type=style&index=1&id=6e3cfbec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3cfbec",
  null
  
)

export default component.exports